import { MyExpRoute } from "apps/myExperience/routes/types";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "shared/context/auth";

export default function useHeaderService() {
  const { logout, isLoggedIn } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = React.useCallback(() => {
    logout();
  }, [logout]);

  const isUserLoggedIn = React.useMemo(() => {
    return isLoggedIn();
  }, [isLoggedIn]);

  const showHomeButton = React.useMemo(
    () => isUserLoggedIn && location.pathname !== MyExpRoute.HOME.path && location.pathname.indexOf("home") === -1,
    [location.pathname, isUserLoggedIn]
  );

  const navigateToHome = React.useCallback(() => {
    navigate(MyExpRoute.HOME.path);
  }, [navigate]);

  return { handleLogout, isUserLoggedIn, showHomeButton, navigateToHome };
}
